import storeImage from '../assets/store_selected.png';
import storeSelectedImage from '../assets/store.png';
const woosmapPublicKey = "woos-3cb8caa3-ad4d-3e7b-b7d6-221a7b72398d";

const mobileBreakPoint = 768;
const mapPaddings: { [key: string]: woosmap.map.Padding } = {
    mobile: { left: 60, right: 60, top: 170, bottom: 70 },
    full: { left: 450, right: 100, top: 150, bottom: 150 },
};


const storesStyle: woosmap.map.Style = {
    breakPoint: 10,
    rules: [],
    default: {
        color: "#f0077b",
        size: 8,
        minSize: 3,
        icon: {
            url: storeImage,
            scaledSize: {
                height: 42,
                width: 32,
            },
        },
        selectedIcon: {
            url: storeSelectedImage,
            scaledSize: {
                height: 42,
                width: 32,
            },
        },
    },
};

const mapStyleOptions: woosmap.map.MapStyleSpec[] = [{
    featureType: "water",
    elementType: "geometry.fill",
    stylers: [{
        color: "#d3d3d3"
    }]
}, {
    featureType: "water",
    elementType: "labels",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "road",
    stylers: [{
        visibility: "on"
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.fill",
    stylers: [{
        color: "#a7a7a7"
    }]
}, {
    featureType: "administrative",
    elementType: "geometry.stroke",
    stylers: [{
        color: "#d3d3d3"
    }]
}, {
    featureType: "landscape",
    elementType: "geometry.fill",
    stylers: [{
        visibility: "on"
    }, {
        color: "#efefef"
    }]
}, {
    featureType: "landscape.natural",
    elementType: "labels",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [{
        visibility: "on"
    }, {
        color: "#ffffff"
    }]
}, {
    featureType: "landscape.man_made",
    elementType: "geometry.stroke",
    stylers: [{
        visibility: "on"
    }, {
        color: "#efefef"
    }]
}, {
    featureType: "administrative",
    elementType: "labels.text.fill",
    stylers: [{
        visibility: "on"
    }, {
        color: "#737373"
    }]
}, {
    featureType: "poi",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "road",
    elementType: "geometry.stroke",
    stylers: [
        {
            color: "#b3b3b3"
        },
        { weight: 3 }
    ]
}, {
    featureType: "road",
    elementType: "geometry.fill",
    stylers: [
        {
            color: "#ffffff"
        }, { weight: 2 }
    ]
}, {
    featureType: "road.local",
    elementType: "geometry.stroke",
    stylers: [{
        visibility: "off"
    }]
}, {
    featureType: "road.local",
    elementType: "geometry.fill",
    stylers: [{
        visibility: "on"
    }, {
        color: "#d3d3d3"
    }, {
        weight: 2
    }]
}, {
    featureType: "road",
    elementType: "labels",
    stylers: [{
        visibility: "on"
    }]
}, {
    featureType: "road.local",
    elementType: "labels",
    stylers: [{
        visibility: "on"
    }]
}, { featureType: "all", stylers: [{ "saturation": -100 }] },];

const mapOptions: woosmap.map.MapOptions = {
    center: { lat: 49, lng: 9 },
    zoom: 5,
    enableMarkerAccessibleNavigation: true
};

const geoLocationOptions: Record<string, number> = {
    radius: 50,
    zoom: 11
}
const baseFilterConf = 'type: "JR"'
export default {
    mapOptions: mapOptions,
    mapStyleOptions: mapStyleOptions,
    storesStyle: storesStyle,
    mapPaddings: mapPaddings,
    mobileBreakPoint: mobileBreakPoint,
    woosmapPublicKey: woosmapPublicKey,
    geoLocationOptions: geoLocationOptions,
    baseFilter: baseFilterConf
}